module.exports = __webpack_public_path__ + "img/close.eaae95d9.png";